<template>
	<Error :errors="errors"/>
    
    <Button label="Dashboard MTI" class="p-button-rounded my-3" />

	<div class="card ">
		<h5>Filter</h5>
		<hr>
		<div class="p-fluid">
			<div class="formgrid grid">
                <div class="field col-12 md:col-6 lg:col-3">
                    <label>User</label>
                    <MultiSelect id="userweb_id" dataKey="userweb_id" v-model="userweb_ids" :loading="loadingDropdownASPM"
                        :options="dataDropdownASPM"
                        optionLabel="label" placeholder="Pilih User" :filter="true" :showToggleAll="false"
                        :showClear="true" @filter="searchDropdownASPM($event, 'filter')"/>
                </div>
			</div>
		</div>
        <Button label="Clear Filter" icon="pi pi-times" class="p-button-warning mr-2 my-1" @click="clearFilter"/>
	</div>

	<div class="grid">
		<div class="col-12 md:col-6 lg:col-4">
			<UserAktif :filter="filters"/>
        </div>
		<div class="col-12 md:col-6 lg:col-4">
			<Outlet :filter="filters"/>
        </div>
	</div>

	<hr>

	<div class="card ">
		<h5>Filter</h5>
		<hr>
		<div class="p-fluid">
            <div class="formgrid grid">
                <div class="field col-12 md:col-6 lg:col-3">
                    <label>Period</label>
                    <Dropdown dataKey="month" v-model="filters2.period" :loading="loadingDropdownPeriod"
                        :options="dataDropdownPeriod"
                        optionLabel="label" optionValue="month" placeholder="Pilih Bulan"
                        :showClear="false"
                     />
                </div>
            </div>
		</div>
	</div>

    <div class="grid mt-2 mb-2">
        <div class="col-12 md:col-6 lg:col-4">
            <EC :filter="filters" :filter2="filters2"/>
        </div>
        <div class="col-12 md:col-6 lg:col-4">
            <NonEC :filter="filters" :filter2="filters2"/>
        </div>
    </div>

    <div class="card ">
        <div class="grid">
            <div class="col-12 md:col-6 lg:col-6">
                <h4>Visit</h4>
                <VisitChart :filter="filters" :filter2="filters2"/>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
                <h4>Top 10 Products</h4>
                <Top10ProductsChart :filter="filters" :filter2="filters2"/>
            </div>
            <div class="col-12 md:col-12 lg:col-12">
                <h4>AVERAGE SKU PER OUTLET</h4>
                <AvgSkuPerOutletChart :filter="filters" :filter2="filters2"/>
            </div>
        </div>
    </div>

	<div class="grid mt-2 mb-2">
		<div class="col-12">
			<div class="card ">
				<h4>MAPS</h4>
				<Map :filter="filters" :filter2="filters2"/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import UserAktif from '../components/dashboard/mti/UserAktif.vue';
import Outlet from '../components/dashboard/mti/Outlet.vue';
import VisitChart from '../components/dashboard/mti/VisitChart.vue';
import EC from '../components/dashboard/mti/EC.vue';
import NonEC from '../components/dashboard/mti/NonEC.vue';
import Top10ProductsChart from '../components/dashboard/mti/Top10ProductsChart.vue';
import AvgSkuPerOutletChart from '../components/dashboard/mti/AvgSkuPerOutletChart.vue';
import Map from '../components/dashboard/mti/MapNew.vue';
import Error from '../components/Error.vue';

export default {
	components: {
		'UserAktif': UserAktif,
		'Outlet': Outlet,
		'VisitChart': VisitChart,
		'EC': EC,
		'NonEC': NonEC,
		'Top10ProductsChart': Top10ProductsChart,
		'AvgSkuPerOutletChart': AvgSkuPerOutletChart,
		'Map': Map,
		'Error': Error,
	},
	computed:{
        ...mapGetters(['errors']),
    },
	data() {
        const today = new Date();
        const currentMonth = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0');
        
		return {		
			appsName: process.env.VUE_APP_APPS_NAME,

            // loading
            loadingDropdownASPM: false,
            loadingDropdownPeriod: false,

            // dataDropdown
            dataDropdownASPM: null,
            dataDropdownPeriod: null,

            // filter
            filters: {
                userweb_id: null,
            },
            userweb_ids: null,
            // filter 2
            filters2: {
                period: currentMonth,
            },
		}
	},    
	mounted() {
        this.searchDropdownASPM('');
        this.searchDropdownPeriod();
    },
    watch: {
        userweb_ids() {
            this.filters.userweb_id = this.userweb_ids ? this.convertMultiSelectUser(this.userweb_ids) : null;
        },
    },
	methods: {
        convertMultiSelectUser(data) {
            if(data){
                return data.map((item) => {
                    return item.userweb_id;
                });
            }
        },
        clearFilter(){
            this.filters.userweb_id = null;
            this.userweb_ids = null;
        },
        clearFilter2(){
            this.filters3.otype_id = null;
        },
        //DROPDOWN
        searchDropdownASPM(event, purpose, valueEdit) {
            setTimeout(() => {
                if (valueEdit) {
                    this.$refs.dsalesman.filterValue = valueEdit;
                }

                if (purpose == "filter") {
                    this.loadingDropdownASPM = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/aspm',
                    params: {
                        "search": valueEdit ? valueEdit : event.value,
                    }
                })
                    .then(res => {

                        if (purpose == "filter") {
                            this.dataDropdownASPM = res.data.data;
                            this.loadingDropdownASPM = false;

                            //Multiple Selected
                            if(this.userweb_ids){
                                this.dataDropdownASPM.push(...this.userweb_ids);

                                const uniqueids= [];
                                this.dataDropdownASPM = this.dataDropdownASPM.filter((c) => {
                                    const isDup = uniqueids.includes(c.userweb_id);
                                    if(!isDup){
                                        uniqueids.push(c.userweb_id);
                                        return true;
                                    } 
                                    return false;
                                });
                            }

                        } else if (purpose == null) {
                            this.dataDropdownASPM = res.data.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }, 250);
        },
        searchDropdownPeriod() {
            setTimeout(() => {
                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/month',
                })
                .then(res => {
                    this.dataDropdownPeriod = res.data.data;
                    this.loadingDropdownPeriod = false;
                })
                .catch((err) => {
                    console.log(err);
                });
            }, 250);
        },
	}
}
</script>
<style>
	.banner {
		width: 100%;
		/* height: 200px; */
		background-color: #f0f0f0;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.banner img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
	}
</style>